export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const LOGOUT = 'LOGOUT';